<template>

  <div class="pt-2">
    <v-card flat>
      <v-form>
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>分类名称：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.name"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>分类编号：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.id"
              single-line
              outlined
              dense
            ></v-text-field>
          </v-col>
          
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" depressed @click="handleSearch"
            >查询</v-btn>
            <v-btn depressed @click="handleResetSearch">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
        :loading="loading"
        :server-items-length="total"
        :page.sync="filter.page"
        :items-per-page.sync="filter.pageSize"
        @update:page="handlePageChanged"
        @update:items-per-page="handlePageSizeChanged"
      >
		<template v-slot:item.status="{ item }">
			{{item.status==1?'启用':'停用'}}
		</template>
        <template v-slot:item.actions="{ item }">
			<v-btn text color="primary" small @click="setting(item)"
			  >项目设置</v-btn>
			<v-btn text color="primary" small @click="stop(item)"
            >停用</v-btn>
        </template>
        <template v-slot:no-data> 查询出错或没有数据 </template></v-data-table
      >
    </v-card>
  </div>

</template>

<script>
import {default as CategoryApi} from "@/api/pd/category/CategoryApi.js";
export default {
  data() {
    return {
      tab: 'list',
      filter: {
		name:'',
		id:'',
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "分类编号",
          align: "start",
          width: 120,
          sortable: false,
          value: "id",
        },
        { text: "分类名称", value: "name", width: 120, sortable: false },
        { text: "检查项数量", value: "assessNum", width: 120, sortable: false },
        { text: "状态", value: "status", width: 120, sortable: false },
        { text: "最后修改人", value: "updateBy", width: 120, sortable: false },
        { text: "最后修改时间", value: "updateTime", width: 120, sortable: false },
        { text: "操作", align: "center", value: "actions", sortable: false, width: 120 },
      ],
      items: [],
      loading: false,
      total: 0,
    };
  },
  methods:{
	  getQueryParams(query) {
	    console.log(query)
	    return query
	  },
	  handleSearch(){
		  this.getDataFromApi();	 
	  },
	  handleResetSearch(){
		  this.filter.id='';
		  this.filter.name='';
		  this.getDataFromApi();
	  },
	  getDataFromApi(){
		  let query=this.getQueryParams(this.filter);
		  CategoryApi.listCategory(query).then(resp=>{
		  			  console.log(resp);
		  			  let rows =resp.data.result.rows
		  			  let total=resp.data.result.total
		  			  this.items=rows
		  			  this.total=total
		  });
	  },
	  setting(item){
		console.log(item.id)
		if(item.id>=3){
			this.$emit("addCallback", {formStatus:'set3',category:item})
		}else{
			this.$emit("addCallback", {formStatus:'set'+item.id,category:item})
		}
	  },
	  handlePageChanged(){
		  
	  },
	  handlePageSizeChanged(){
		  
	  }
  },
  mounted(){
	  this.getDataFromApi();
  }
};
</script>